import React, { Suspense, lazy, useEffect, useState } from 'react';
import Landing from './components/Landing';

// Desktop is a whole OS: windows, terminal, games, jspdf, syntax highlighting.
// A landing visitor may never open it, and having it in the main bundle is what
// pushed LCP render delay past three seconds. Loaded on demand instead.
const Desktop = lazy(() => import('./components/Desktop'));

// ponytail: hash instead of react-router — two modes, one boolean
const readMode = () => (window.location.hash === '#desktop' ? 'desktop' : 'landing');

function App() {
  const [mode, setMode] = useState(readMode);

  useEffect(() => {
    const onHash = () => setMode(readMode());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mode === 'desktop' ? 'hidden' : '';
    if (mode === 'landing') window.scrollTo(0, 0);
  }, [mode]);

  if (mode === 'desktop') {
    return (
      <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: '#080b12' }} />}>
        <Desktop />
      </Suspense>
    );
  }
  return <Landing onEnterDesktop={() => { window.location.hash = 'desktop'; }} />;
}

export default App;
